"use strict";

(function () {
    const root = document.querySelector(".loancalc");
    if (!root) return;

    const EGENKAPITAL_MIN_RATIO = 0.1; // Egenkapital må være minst 10 % av kjøpesum

    // Leser et data-attributt (min/maks/default fra Sitecore) og returnerer det som tall, 0 hvis ugyldig.
    function num(root, name) {
        const v = parseFloat(root.dataset[name]);
        return isNaN(v) ? 0 : v;
    }

    const cfg = {
        kjopesum: { min: num(root, "kjopesumMin"), max: num(root, "kjopesumMax"), def: num(root, "kjopesumDefault") },
        tid: { min: num(root, "nedbetalingstidMin"), max: num(root, "nedbetalingstidMax"), def: num(root, "nedbetalingstidDefault") },
        rente: { min: num(root, "renteMin"), max: num(root, "renteMax"), def: num(root, "renteDefault") },
    };

    const els = {
        form: root.querySelector(".loancalc__form"),
        result: root.querySelector(".loancalc__result"),
        kjopesum: root.querySelector("#kc-kjopesum"),
        egenkapital: root.querySelector("#kc-egenkapital"),
        tid: root.querySelector("#kc-nedbetalingstid"),
        rente: root.querySelector("#kc-rente"),
        resMonthly: root.querySelector("#kc-res-monthly"),
        resRenter: root.querySelector("#kc-res-renter"),
        resAvdrag: root.querySelector("#kc-res-avdrag"),
        resKjopesum: root.querySelector("#kc-res-kjopesum"),
    };

    let egenkapitalDirty = false; // settes når brukeren selv redigerer egenkapital

    // --- formatering / parsing -------------------------------------------------

    // Tolker en innskrevet streng til tall: fjerner mellomrom (tusenskille) og gjør komma om til punktum.
    function parseNum(str) {
        if (str == null) return NaN;
        return parseFloat(String(str).replace(/\s/g, "").replace(",", "."));
    }

    // Formaterer et heltall med non-breaking space som tusenskille (f.eks. 1 500 000) sa tallet ikke brytes over flere linjer.
    function formatInt(n) {
        return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");
    }

    // Formaterer rente med komma som desimalskille (f.eks. 4,5).
    function formatRente(n) {
        return String(n).replace(".", ",");
    }

    // Henter tallverdien fra et input-felt, 0 hvis feltet er tomt/ugyldig.
    function fieldValue(el) {
        const v = parseNum(el.value);
        return isNaN(v) ? 0 : v;
    }

    // --- init ------------------------------------------------------------------

    els.kjopesum.value = formatInt(cfg.kjopesum.def);
    els.egenkapital.value = formatInt(Math.round(cfg.kjopesum.def * EGENKAPITAL_MIN_RATIO));
    els.tid.value = String(Math.round(cfg.tid.def));
    els.rente.value = formatRente(cfg.rente.def);

    // --- formatering pa fokus/blur for kr-feltene ------------------------------

    // Fjerner tusenskille når feltet får fokus, så brukeren redigerer et rent tall.
    function stripOnFocus(el) {
        el.addEventListener("focus", function () {
            if (el.value.trim() === "") return;
            el.value = String(Math.round(fieldValue(el)));
        });
    }
    // Legger på tusenskille igjen når feltet mister fokus.
    function formatOnBlur(el) {
        el.addEventListener("blur", function () {
            if (el.value.trim() === "") return;
            el.value = formatInt(fieldValue(el));
        });
    }
    [els.kjopesum, els.egenkapital].forEach(function (el) {
        stripOnFocus(el);
        formatOnBlur(el);
    });

    // Egenkapital folger 10 % av kjopesum til brukeren redigerer feltet selv
    els.kjopesum.addEventListener("input", function () {
        if (egenkapitalDirty) return;
        const ek = Math.round(fieldValue(els.kjopesum) * EGENKAPITAL_MIN_RATIO);
        els.egenkapital.value = document.activeElement === els.egenkapital ? String(ek) : formatInt(ek);
    });
    els.egenkapital.addEventListener("input", function () {
        egenkapitalDirty = true;
    });

    els.rente.addEventListener("blur", function () {
        if (els.rente.value.trim() === "") return;
        els.rente.value = formatRente(fieldValue(els.rente));
    });

    // --- validering ------------------------------------------------------------

    // Viser feilmelding og markerer feltet som ugyldig; kall med null som melding for å fjerne feilen.
    function setError(el, message) {
        const field = el.closest(".loancalc__field");
        const errEl = field.querySelector(".loancalc__error");
        if (message) {
            errEl.textContent = message;
            errEl.hidden = false;
            field.classList.add("loancalc__field--invalid");
        } else {
            errEl.textContent = "";
            errEl.hidden = true;
            field.classList.remove("loancalc__field--invalid");
        }
    }

    // Validerer alle feltene mot min/maks og egenkapital-reglene. Returnerer true bare hvis alt er gyldig.
    function validate(values) {
        let ok = true;
        setError(els.kjopesum, null);
        setError(els.egenkapital, null);
        setError(els.tid, null);
        setError(els.rente, null);

        if (values.sum < cfg.kjopesum.min || values.sum > cfg.kjopesum.max) {
            setError(els.kjopesum, "Kjøpesum må være mellom " + formatInt(cfg.kjopesum.min) + " og " + formatInt(cfg.kjopesum.max) + " kr.");
            ok = false;
        }
        if (values.tid < cfg.tid.min || values.tid > cfg.tid.max) {
            setError(els.tid, "Nedbetalingstid må være mellom " + cfg.tid.min + " og " + cfg.tid.max + " år.");
            ok = false;
        }
        if (values.rente < cfg.rente.min || values.rente > cfg.rente.max) {
            setError(els.rente, "Rente må være mellom " + formatRente(cfg.rente.min) + " og " + formatRente(cfg.rente.max) + " %.");
            ok = false;
        }
        const minEk = values.sum * EGENKAPITAL_MIN_RATIO;
        if (values.kapital < minEk) {
            setError(els.egenkapital, "Egenkapital må være minst 10 % av kjøpesum (" + formatInt(minEk) + " kr).");
            ok = false;
        } else if (values.kapital > values.sum) {
            setError(els.egenkapital, "Egenkapital kan ikke være høyere enn kjøpesummen.");
            ok = false;
        }
        return ok;
    }

    // --- beregning -------------------------------------------------------------

    // Regner ut lån (kjøpesum minus egenkapital) og fyller resultatboksen med månedskostnad, renter, avdrag og kjøpesum.
    function calculate(values) {
        const sum = values.sum;
        const kapital = values.kapital;
        const avdrag = Math.max(0, sum - kapital);
        const r = values.rente / 100 / 12;
        const n = values.tid * 12;

        const monthly = r === 0 ? avdrag / n : (r * avdrag * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
        const renter = monthly * n - avdrag;

        els.resMonthly.textContent = formatInt(monthly);
        els.resRenter.textContent = formatInt(renter);
        els.resAvdrag.textContent = formatInt(avdrag);
        els.resKjopesum.textContent = formatInt(sum);
    }

    // Nullstiller hele resultatboksen (brukes når validering feiler etter at et resultat er vist).
    function resetResult() {
        els.resMonthly.textContent = "0";
        els.resRenter.textContent = "0";
        els.resAvdrag.textContent = "0";
        els.resKjopesum.textContent = "0";
    }

    els.form.addEventListener("submit", function (e) {
        e.preventDefault();
        const values = {
            sum: fieldValue(els.kjopesum),
            kapital: fieldValue(els.egenkapital),
            tid: fieldValue(els.tid),
            rente: fieldValue(els.rente),
        };
        if (validate(values)) {
            calculate(values);
            // Pa mobil ligger resultatet under skjemaet - rull det inn i visning, med klaring
            // for den sticky headeren (mal hoyden og bruk scroll-margin-top).
            if (!window.matchMedia("(min-width: 48em)").matches && els.result) {
                const header = document.querySelector(".hdr");
                els.result.style.scrollMarginTop = (header ? header.offsetHeight + 8 : 0) + "px";
                els.result.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        } else {
            resetResult();
        }
    });
})();
